module.exports = __webpack_public_path__ + "img/side-icon-52.2edf2b9a.svg";